import React, { useState, useEffect, useCallback } from 'react'
import { EmblaOptionsType } from 'embla-carousel'
import useEmblaCarousel from 'embla-carousel-react'
import { Thumb } from './Thumb'
import '../../../css/embla.css';

type PropType = {
  images: string[]
  options?: EmblaOptionsType
}

export default function ImageGallery({ images, options }) {
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [emblaMainRef, emblaMainApi] = useEmblaCarousel(options)
  const [emblaThumbsRef, emblaThumbsApi] = useEmblaCarousel({
    containScroll: 'keepSnaps',
    dragFree: true
  })

  useEffect(() => {
    console.log(selectedIndex)
  }, [selectedIndex])

  const onThumbClick = useCallback(
    (index: number) => {
      if (!emblaMainApi || !emblaThumbsApi) return
      emblaMainApi.scrollTo(index)
    },
    [emblaMainApi, emblaThumbsApi]
  )

  const onSelect = useCallback(() => {
    if (!emblaMainApi || !emblaThumbsApi) return
    setSelectedIndex(emblaMainApi.selectedScrollSnap())
    emblaThumbsApi.scrollTo(emblaMainApi.selectedScrollSnap())
  }, [emblaMainApi, emblaThumbsApi, setSelectedIndex])

  useEffect(() => {
    if (!emblaMainApi) return
    onSelect()

    emblaMainApi.on('select', onSelect).on('reInit', onSelect)
  }, [emblaMainApi, onSelect])

  return (
    <div className="embla justify-items-center">
      <div className="embla__viewport max-w-[400px]" ref={emblaMainRef}>
        <div className="embla__container">
          {images.map((image, index) => (
            <div className="embla__slide" key={index}>
              <img src={image} alt="Main product" className="w-full object-contain" />

            </div>
          ))}
        </div>
      </div>

      {images.length > 1 ? (
        <div className="embla-thumbs w-full">
          <div className="embla-thumbs__viewport pr-1" ref={emblaThumbsRef}>
            <div className="flex gap-x-2 p-2">
              {images.map((url, index) => (
                <Thumb
                  key={index}
                  onClick={() => onThumbClick(index)}
                  selected={index === selectedIndex}
                  url={url}
                />
              ))}
            </div>
          </div>
        </div>
      ) : null}

    </div>
  )
}